import config from '../config';
import CtaBand from '../components/CtaBand';
import Footer from '../components/Footer';

// ── ABOUT PAGE CONTENT ─ edit here ────────────────────────────

const VALUES = [
  {
    title: 'SPECIALISERING',
    desc:  'Vi fokuserar på kyl, frys och värme. Det ger en djup kompetens – inom installation, service och felsökning – som generalister aldrig kan matcha.',
    icon: (
      <svg className="vi" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
      </svg>
    ),
  },
  {
    title: 'SNABBHET',
    desc:  'En havererad kylanläggning är en kris. Vi prioriterar snabb respons och strävar alltid mot utryckning inom 4 timmar i Göteborgsregionen.',
    icon: (
      <svg className="vi" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
      </svg>
    ),
  },
  {
    title: 'ÄRLIGHET',
    desc:  'Inga dolda avgifter och ingen överdrift. Du vet exakt vad som behöver göras och vad det kostar – innan vi sätter igång.',
    icon: (
      <svg className="vi" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
      </svg>
    ),
  },
];

const PROCESS = [
  { num: '01', title: 'KONTAKT',   icon: '📞', desc: 'Du ringer eller mailar. Vi svarar snabbt och bedömer om det är akut eller planerat.' },
  { num: '02', title: 'OFFERT',    icon: '📋', desc: 'Tydligt prisförslag utan dolda avgifter. Du godkänner innan vi börjar – inga överraskningar.' },
  { num: '03', title: 'UTFÖRANDE', icon: '🔧', desc: 'Tekniker utför installation, service eller felsökning med rätt utrustning och reservdelar på plats.' },
  { num: '04', title: 'KLART',     icon: '✅', desc: 'Du får serviceprotokoll och dokumentation. Vi följer upp för att säkerställa att allt fungerar.' },
];

// ══════════════════════════════════════════════════════════════
export default function About({ navigate }) {
  return (
    <>
      {/* ── INTRO ── */}
      <div className="at">
        <div>
          <div className="sl">Om oss</div>
          <div className="st" style={{ fontSize:'clamp(2.8rem,5vw,4.2rem)' }}>
            OM<br />BECOOL<br />STORKÖK
          </div>
          <p className="al">
            Vi på BeCool är specialister på kyla, värme och storköksmaskiner.
            För butik, fastighet och hushåll utför vi projektering, installation,
            reparation och service av kyla-, värme- och storköksutrustning.
          </p>
          <p className="al" style={{ marginTop:14 }}>
            Vi utför installation, service och felsökning på kyl, frys, värmesystem och
            storköksutrustning för restauranger, livsmedelsbutiker och hotell i hela Västra Götaland.
          </p>
          <div style={{ display:'flex', gap:14, marginTop:32, flexWrap:'wrap' }}>
            <button className="bp" onClick={() => navigate('contact')}>Begär offert</button>
            <button className="bo" onClick={() => navigate('services')}>Se tjänster</button>
          </div>
        </div>

        <div style={{ position:'relative' }}>
          <div className="ai">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
              <polyline points="9 22 9 12 15 12 15 22"/>
            </svg>
          </div>
          <div className="aitag">GÖTEBORG<br />&amp; VÄSTRA GÖTALAND</div>
        </div>
      </div>

      {/* ── VALUES ── */}
      <div className="vw">
        <div className="sl">Våra värderingar</div>
        <div className="st">SÅ HÄR JOBBAR VI</div>
        <div className="ss">Tre principer styr varje uppdrag – oavsett om det gäller installation, service eller felsökning.</div>
        <div className="vg">
          {VALUES.map(({ title, desc, icon }) => (
            <div className="vc" key={title}>
              {icon}
              <div className="vt">{title}</div>
              <div className="vd">{desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── PROCESS ── */}
      <div className="psec">
        <div className="sl">Hur vi arbetar</div>
        <div className="st">FRÅN KONTAKT TILL KLART</div>
        <div className="ss">Oavsett om det gäller installation, service eller felsökning – så här ser ett typiskt uppdrag ut.</div>
        <div className="pg">
          {PROCESS.map(({ num, title, desc }) => (
            <div className="ps" key={num}>
              <div className="psn">{num}</div>
              <div className="pst">{title}</div>
              <div className="psd">{desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── AREAS ── */}
      <div className="asec">
        <div className="sl">Verksamhetsområde</div>
        <div className="st">VI KÖR HELA REGIONEN</div>
        <div className="ss">Baserade i Göteborg men vi servar hela Västra Götaland. Ring oss så berättar vi om vi täcker ditt område.</div>
        <div className="aps">
          {config.areas.map(({ name, highlight }) => (
            <span className={`ap${highlight ? ' hl' : ''}`} key={name}>{name}</span>
          ))}
        </div>
      </div>

      {/* ── CTA ── */}
      <CtaBand
        label="Kontakta oss"
        heading="LÅT OSS HÖRA AV DIG"
        text="Installation, service eller felsökning – vi hjälper dig snabbt och ärligt. Ring jouret dygnet runt."
        btnLabel="Begär offert"
        onAction={() => navigate('contact')}
      />

      <Footer navigate={navigate} />
    </>
  );
}
